var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrawkitDailyLifeVectorIllustration05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1323 1169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b57e6f;}.cls-2{isolation:isolate;}.cls-3{fill:#3a193f;}.cls-16,.cls-17,.cls-21,.cls-26,.cls-28,.cls-32,.cls-33,.cls-4{fill:none;}.cls-16,.cls-4{stroke:#3a193f;}.cls-16,.cls-17,.cls-32,.cls-33,.cls-4{stroke-linecap:round;}.cls-16,.cls-17,.cls-19,.cls-32,.cls-33,.cls-4{stroke-linejoin:round;}.cls-12,.cls-19,.cls-21,.cls-25,.cls-26,.cls-28,.cls-32,.cls-33,.cls-4{stroke-width:3px;}.cls-5{clip-path:url(#clip-path);}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:#41465a;}.cls-8{fill:#f1b104;}.cls-9{clip-path:url(#clip-path-3);}.cls-10{fill:#e3e3e3;mix-blend-mode:multiply;}.cls-11{fill:#ebf4f7;}.cls-12,.cls-19,.cls-22,.cls-27{fill:#fff;}.cls-12,.cls-19,.cls-25,.cls-28{stroke:#f1b104;}.cls-12,.cls-21,.cls-25,.cls-26,.cls-28{stroke-miterlimit:10;}.cls-13{fill:#f0512f;}.cls-14{fill:#f26b4e;}.cls-15{fill:#c6efff;}.cls-16,.cls-17{stroke-width:2px;}.cls-17{stroke:#9e2923;}.cls-18{fill:#e4f7ff;}.cls-20,.cls-25{fill:#ffe6aa;}.cls-21{stroke:#948900;}.cls-23{fill:#b0a81f;}.cls-24{fill:#db9a8f;}.cls-26,.cls-33{stroke:#41465a;}.cls-27{opacity:0.85;}.cls-29{fill:#2b303f;}.cls-30{fill:#6db1ba;}.cls-31{fill:#ffb3a4;}.cls-32{stroke:#e2564b;}.cls-34{fill:#fff4de;}.cls-35{fill:#242854;}.cls-36{fill:#948900;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M980.72,228.22s-2.77,38.85,23.49,50.62c0,0-31.27,25.27-65.25,4.18,0,0,21.2-4.16,12.16-51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LEG",
    className: "cls-1",
    d: "M989.39,805.84l0-.23C980.93,757.25,942,539,1020.21,527.78c14.57-2.09,62.18,14.91,57.27,104.36-3.94,72-25.89,124.61-29.55,168.22v0c-.08,35.87,15.12,54,19.2,84.86,5.67,43-6.91,114.15-15.86,147.8h0c-.33,3.38-.33,15.31,3.67,21.16s6,6.22,5.27,12.78h-46a11.55,11.55,0,0,1,7.82-9.94c7.45-2.48,16.6-19.94,14.71-27.39v0c-11.24-42.77-30.39-133.81-32.89-147.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LEG-2",
    "data-name": "LEG",
    className: "cls-1",
    d: "M938.76,802.77c-3.72,35.69,9.57,55.18,10.5,86.3,1.22,41.18-17.67,105.09-30.64,138.79l0,.08c-1.71,4.47-1.37,13.48.51,18.28,3.28,8.35,6,20.78-5.48,20.78H850.56s-1.46-8.16,15.27-10.47c16.14-2.23,37-11.42,36.87-27.17-6.26-42.45-15-135.47-16.09-149.59-1.27-16.39-5.2-59.82-6.36-73.66a.07.07,0,0,1,0-.05c-4.62-42.85-28.87-271.54,47-278.11,14.67-1.27,61.2,18.4,51,107.43C970.49,703,947.76,752.47,940,794.26a0,0,0,0,0,0,0C939.55,797.33,939,800.22,938.76,802.77Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 999.1,
    cy: 155.44,
    r: 25.98
  }), /*#__PURE__*/React.createElement("g", {
    id: "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M916.55,182c5.16-5.28,28.46-19.87,41.43-24.15,11-3.64,34.9-5.67,44.56,16s.32,40.42,14.72,53.36S1107.16,250,1075,333.12c-14.74,38-169.78-8.41-175.13-50.07-3.48-27.09,35-38.34,30.29-46.7C924.14,225.64,896.42,202.61,916.55,182Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M896.33,283.63c-6.09-29.8,32-37.75,30.71-47.91-1.43-11.21-28.71-34.3-8.25-53.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "NECK"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M980.72,228.22s-2.77,38.85,23.49,50.62c0,0-31.27,25.27-65.25,4.18,0,0,21.2-4.16,12.16-51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 963.55,
    cy: 239.01,
    rx: 28.02,
    ry: 24.75
  }))), /*#__PURE__*/React.createElement("path", {
    id: "FACE",
    className: "cls-1",
    d: "M985.59,224c.66,5.14-9.9,25.73-34,28.55-6.66.78-19.84-12.16-21.71-25.24-1.5-10.54-3.35-22.44-3.55-26.17-.31-5.66,3.14-19.13,17.91-22.6h0c5.24-.92,15.49-.71,19.79,13.28,5.23,17,16.94,17.54,22.53,16.59C987.64,207.22,986,221,985.59,224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M937.28,177.78s15.68-5.61,21.58,13.57c5.83,19,16.75,15,24.13,13.45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_LEG",
    "data-name": "RIGHT LEG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LEG-3",
    "data-name": "LEG",
    className: "cls-1",
    d: "M989.39,805.84l0-.23C980.93,757.25,942,539,1020.21,527.78c14.57-2.09,62.18,14.91,57.27,104.36-3.94,72-25.89,124.61-29.55,168.22v0c-.08,35.87,15.12,54,19.2,84.86,5.67,43-6.91,114.15-15.86,147.8h0c-.33,3.38-.33,15.31,3.67,21.16s6,6.22,5.27,12.78h-46a11.55,11.55,0,0,1,7.82-9.94c7.45-2.48,16.6-19.94,14.71-27.39v0c-11.24-42.77-30.39-133.81-32.89-147.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 976.62,
    y: 451.49,
    width: 154.11,
    height: 501.43
  })), /*#__PURE__*/React.createElement("path", {
    id: "SHOES",
    className: "cls-8",
    d: "M1055.52,1054.79c3.92,3.9,5.44,6.83,4.69,12.21h-46s-2-8,10.75-13.37C1029.39,1051.77,1051.27,1050.56,1055.52,1054.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_LEG",
    "data-name": "LEFT LEG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LEG-4",
    "data-name": "LEG",
    className: "cls-1",
    d: "M938.76,802.77c-3.72,35.69,9.57,55.18,10.5,86.3,1.22,41.18-17.67,105.09-30.64,138.79l0,.08c-1.71,4.47-1.37,13.48.51,18.28,3.28,8.35,6,20.78-5.48,20.78H850.56s-1.46-8.16,15.27-10.47c16.14-2.23,37-11.42,36.87-27.17-6.26-42.45-15-135.47-16.09-149.59-1.27-16.39-5.2-59.82-6.36-73.66a.07.07,0,0,1,0-.05c-4.62-42.85-28.87-271.54,47-278.11,14.67-1.27,61.2,18.4,51,107.43C970.49,703,947.76,752.47,940,794.26a0,0,0,0,0,0,0C939.55,797.33,939,800.22,938.76,802.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 837.46,
    y: 451.49,
    width: 154.11,
    height: 501.43
  })), /*#__PURE__*/React.createElement("path", {
    id: "SHOES-2",
    "data-name": "SHOES",
    className: "cls-8",
    d: "M919.1,1046.22s9.5,20.78-4.31,20.78H850.56s-2.59-7.86,14.1-10.47c2.32-.37,9-1.61,9-1.61s-2.06,5.81,12.62,5.18S907.53,1047.24,919.1,1046.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "DRESS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DRESS-2",
    "data-name": "DRESS",
    className: "cls-8",
    d: "M922.59,463.43c-.79-24.09-5.8-47.68-8.71-49.61-9-6-14.56-17.5-13.83-33.06-27.87-4.15-44.76-23.91-44.76-23.91s20.73-36.29,32-49.29c10.5-12.1,30.08-19.16,43.77-22.86L939,283c31.57,19.59,61.79-1.29,65.84-4.35l20.29,7.94c9.46,3.82,21.47,9.41,28.92,18,11.27,13,32,49.29,32,49.29s-22.88,23.5-53.73,26.09c-7.2,29.47-13.26,76-11,83.67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "APRON"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SHADOW",
    className: "cls-10",
    d: "M943.49,283.12l3.18-3.49c-.22,1-11.32,66.08-10.93,80.33h48.81c7.85-24.06,20.76-82.47,20.76-82.47s5.2-.43,4.36,8.18c-2.46,25.26-9.77,65.37-9.77,74.29h.12s10.91,66,36.54,121.78,30,235.21-.41,243.54c-65.08,17.86-131.68,8.28-151.44-4.1-14.22-8.91-12.29-151.17,34.87-225.75,15.8-25-6.35-63.78-7.67-79.69C910,393.17,926.24,360,926.24,360Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "APRON-2",
    "data-name": "APRON",
    className: "cls-11",
    d: "M1031.88,470.05c25.63,55.76,23.22,233-6.84,242.36-64.37,20-128.21,13.77-147.35-1.76-13-10.57-11.7-152.34,35.46-226.92,15.8-25-6.36-63.78-7.68-79.69C903.59,381.47,919.8,360,919.8,360c0-8.92,12.89-72.76,20.18-77.43s7.28-3.49,7.28-3.49-15.43,66.56-15,80.92H981c7.85-24.06,21.93-82.47,21.93-82.47s6.93-2.81,6.7,5.84C1009,306.9,993.47,351,993.47,360h.12A655.56,655.56,0,0,0,1025.27,455c.63-6.91,2.79-22.22,9.2-14.2,4.35,5.45-1.87,13.72-6.09,18.29,6.28,2,19.59,7.41,23.4,17.67l-5.83,4.32-15.22-13.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HANDS"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "CUTTING_BOARD",
    "data-name": "CUTTING BOARD",
    className: "cls-12",
    x: 863.82,
    y: 627.2,
    width: 180.22,
    height: 11.09,
    rx: 4.68
  }), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_HAND",
    "data-name": "RIGHT HAND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HAND",
    className: "cls-1",
    d: "M1031.19,600.16c-13.81,6.26,32.34-112.57,39.92-125.34-9.29-20.46-25.94-61.49-38.52-94.89,16.29-1.44,30.34-8.69,39.94-15.18,0,0,31.5,68.41,31.29,112.43C1103.83,491.18,1055.7,589.05,1031.19,600.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SHADOW-2",
    "data-name": "SHADOW",
    className: "cls-3",
    d: "M1075.68,372.61c-7,7.28-23.52,14.71-38.32,20q-2.94-6.46-5.45-12.58l.68-.06c16.29-1.44,30.34-8.69,39.94-15.18C1073.56,367.26,1074.61,369.87,1075.68,372.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ARM",
    className: "cls-1",
    d: "M1037.89,593.56c-.05-2.54-20.46-6.93-27.61-6.78s-18.28,5-20,6.28-7,8.63-7,8.63,1.76,3.6,6.82-.14,15.63-2.92,17.53-1c4.28,4.35-7.7-.15-9.68,1.39s-1.7,2.91-1.7,2.91,11.92,2.54,13.87,2.87,10.59-1.86,15.19-3.77S1038,597.32,1037.89,593.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TOMATO"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1001.07,
    cy: 611.59,
    rx: 16.54,
    ry: 15.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 998,
    cy: 612.72,
    rx: 12.98,
    ry: 13.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M999.75,608.33c0,.92-1.75,3.43-1.75,3.43s-1.76-2.51-1.76-3.43a1.76,1.76,0,0,1,3.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M996.24,617.1c0-.92,1.76-3.42,1.76-3.42s1.75,2.5,1.75,3.42a1.76,1.76,0,0,1-3.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M993.39,611c1,0,3.6,1.68,3.6,1.68s-2.63,1.67-3.6,1.67a1.68,1.68,0,1,1,0-3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1002.6,614.39c-1,0-3.59-1.67-3.59-1.67s2.62-1.68,3.59-1.68a1.68,1.68,0,1,1,0,3.35Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 983.14,
    cy: 613.55,
    rx: 15.14,
    ry: 12.33,
    transform: "translate(-175.64 598.39) rotate(-31.22)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 981.82,
    cy: 614.1,
    rx: 13.52,
    ry: 11.09,
    transform: "translate(-173.75 689.88) rotate(-35.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M984.29,610.15c-.16.83-2.3,3.09-2.3,3.09s-1.25-2.26-1.08-3.09a2,2,0,0,1,2-1.51A1.28,1.28,0,0,1,984.29,610.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M979.34,618.06c.17-.84,2.31-3.09,2.31-3.09s1.24,2.25,1.08,3.09a2.06,2.06,0,0,1-2,1.5A1.28,1.28,0,0,1,979.34,618.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M977.67,612.6c.94,0,3.18,1.5,3.18,1.5s-2.84,1.51-3.77,1.51a1.28,1.28,0,0,1-1.4-1.51A2.06,2.06,0,0,1,977.67,612.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M986,615.61c-.93,0-3.17-1.51-3.17-1.51s2.83-1.5,3.77-1.5a1.27,1.27,0,0,1,1.39,1.5A2,2,0,0,1,986,615.61Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_HAND",
    "data-name": "LEFT HAND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M830.24,458.19c-1.41,4.88.21,12.22,6.44,21.08,21.88,31.09,77,95.77,94.3,97.62,8.49.9-37.83-85.81-72.15-115.59,7-10.34,23.94-47.65,41.15-80.68-16.4-1.68-29.28-11-37.53-17.18C862.45,363.44,838.13,415.55,830.24,458.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M895,390c-14.21-4.82-28-13.5-34.57-21.5.5-1,1.54-4.05,2-5,8.25,6.13,21,14.39,37.47,17.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 905.54,
    y: 579.32,
    width: 48.42,
    height: 10.42,
    rx: 3.06,
    transform: "translate(254.69 -281.73) rotate(19.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1015.89,613.43l-62.63-22.69-4.35,12S989.71,623.19,1015.89,613.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M926.63,565.12c4.53-.26,24.76,9.38,25.62,11.85s12.25,16.26,12.25,16.26-3,3-7.87-2c-5.71-5.81-8.11-5.59-8.11-5.59s-2,4.13-5,3.83-2,3.66-6.76,4c-2.81.17-4.39,1.95-6.78.64s-9.72-18.12-8.58-23.76C922.39,565.57,923.94,565.28,926.63,565.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TOMATO-2",
    "data-name": "TOMATO"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 926.17,
    y: 620.66,
    width: 27.93,
    height: 4.37,
    rx: 1.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 973.17,
    cy: 615.97,
    rx: 13.82,
    ry: 10.3,
    transform: "translate(-147.22 349.14) rotate(-18.94)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 971.93,
    cy: 616.42,
    rx: 12.26,
    ry: 9.32,
    transform: "translate(-158.41 399.75) rotate(-21.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M974.25,613.2c-.16.68-2.16,2.52-2.16,2.52s-1.16-1.84-1-2.52A1.91,1.91,0,0,1,973,612C973.82,612,974.4,612.52,974.25,613.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M969.62,619.65c.15-.68,2.15-2.52,2.15-2.52s1.17,1.84,1,2.52a1.88,1.88,0,0,1-1.86,1.23C970.05,620.88,969.47,620.33,969.62,619.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M968.06,615.2a10,10,0,0,1,3,1.22,15.76,15.76,0,0,1-3.52,1.23c-.88,0-1.46-.55-1.31-1.23A1.91,1.91,0,0,1,968.06,615.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M975.81,617.65a9.93,9.93,0,0,1-3-1.23,15.85,15.85,0,0,1,3.52-1.22c.88,0,1.46.55,1.31,1.22A1.9,1.9,0,0,1,975.81,617.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M929,204.8s2.08-4.16,9.35-2.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M952.86,214.15s7.47-.72,11.43-4.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M948.7,236s4.16,1,9.36-4.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "944.55 214.15 942.47 223.5 946 227.72"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 983.27,
    cy: 209.42,
    r: 10.39,
    transform: "translate(358.03 996.67) rotate(-63.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M931,216.23s2.94,1.48,8.74-.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M949.74,202.72s4.16-5.53,14.55-1.73"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 765.54,
    cy: 445.89,
    r: 17.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 712.54,
    cy: 439.89,
    r: 17.84
  }), /*#__PURE__*/React.createElement("g", {
    id: "PICTURE"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 666.46,
    y: 149.06,
    width: 140.21,
    height: 140.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 660.25,
    y: 142.85,
    width: 140.21,
    height: 140.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 682.58,
    y: 165.18,
    width: 95.55,
    height: 95.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M730.86,191.59s2.62-8.69-3.49-11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M743.81,205.25a23.87,23.87,0,0,0,3.61,9.16,20.53,20.53,0,1,1-34.31.26,25.44,25.44,0,0,0,3.79-9.42l.12-.71c.15-.86.24-1.72.32-2.59a11.79,11.79,0,0,1,11.75-10.73h2.52A11.81,11.81,0,0,1,743.37,202c.07.87.16,1.73.31,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M732,191.13s-.64-8,10.82-11.57C742.8,179.56,744.39,193.89,732,191.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CHAIR"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M689.1,778.29l-33.37,311.83a3.49,3.49,0,0,0,3.47,3.87h0a3.5,3.5,0,0,0,3.43-2.83l54.25-312.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M817.06,778.29l33.37,305.82A3.5,3.5,0,0,1,847,1088h0a3.5,3.5,0,0,1-3.44-2.83L789.28,778.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 662.08,
    y: 759.14,
    width: 179.35,
    height: 19.14,
    rx: 8.07
  })), /*#__PURE__*/React.createElement("g", {
    id: "GIRL"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEGS-2",
    "data-name": "LEGS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LEFT_LEG-2",
    "data-name": "LEFT LEG",
    className: "cls-3",
    d: "M850.89,753.79c-1,6.85-45.41,3.15-141.7,4.29a2.74,2.74,0,0,1-.56.06c-18,0-32.55-27.32-33-98.41s25.62-74.82,34.73-74.43c26.9,1.12,28.79,40,28.79,75a209.94,209.94,0,0,1-5.82,49c18.38,7,21-2.59,53.06,5C821.12,722.59,851.66,748.34,850.89,753.79Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_LEG-2",
    "data-name": "RIGHT LEG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SHOES-3",
    "data-name": "SHOES",
    className: "cls-8",
    d: "M891.68,746.91c3.79,1.75,9.63-.28,13-.33,8-.13,9.63,4.42,9.63,4.42L895.4,793.13s-7.19-2.06-5.78-14.54c1.47-13,2.11-18.64-5-20.76S885.42,744,891.68,746.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LEG-5",
    "data-name": "LEG",
    className: "cls-24",
    d: "M884.58,757.65c-20.32,1.1-61.7-.35-126.7.43a2.76,2.76,0,0,1-.57.06c-28.9,0-32.55-27.32-33-98.41s25.61-74.82,34.72-74.43c26.9,1.12,28.79,40,28.79,75a209.66,209.66,0,0,1-6.32,51c15.83,4.81,21.52-4.59,53.57,3,34.71,8.23,54.85,27.24,57.27,34.62C893.07,751.12,894.36,757.13,884.58,757.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SHADOW-3",
    "data-name": "SHADOW",
    className: "cls-3",
    d: "M787.84,660.34a210,210,0,0,1-4.53,43.29,340.47,340.47,0,0,1-57.79.29c-.79-12.31-1.08-27-1.19-44.19-.44-71.09,25.61-74.81,34.72-74.43C786,586.42,787.84,625.31,787.84,660.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_HAND-2",
    "data-name": "LEFT HAND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HAND-2",
    "data-name": "HAND",
    className: "cls-24",
    d: "M660.89,547.41c26.48-18.53,55.63-49,58.34-60.86,3.28-14.36-5.76-30.57-16.79-21.19-16.09,13.69-41.09,38.3-52.4,52.87-16.58-16.31-52.35-49.12-63.25-42.3-4.62,2.89,45,64.56,54.4,72.49C646.61,553,656.09,550.76,660.89,547.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PACK"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 535.44,
    y: 539.45,
    width: 82.52,
    height: 11.93,
    transform: "translate(-214.65 483.51) rotate(-38.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M612.54,524.13l-4.24,3.43,0,0a6,6,0,0,1-7.46-9.31l4.24-3.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "512.32 531.55 540.85 566.7 605.04 514.85 576.51 479.7 512.32 531.55"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 605.45,
    cy: 525.1,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 613.8,
    cy: 531.98,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 619.09,
    cy: 548.98,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 612.79,
    cy: 553.4,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 620.35,
    cy: 563.44,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 623.55,
    cy: 557.83,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 610.26,
    cy: 544.23,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 609,
    cy: 534.51,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 613.44,
    cy: 536.04,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 610.86,
    cy: 530.72,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 616.53,
    cy: 540.92,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 618.07,
    cy: 557.36,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 627.66,
    cy: 572.99,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 619.09,
    cy: 567.97,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 625.85,
    cy: 564.35,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 614.34,
    cy: 567.97,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 614.34,
    cy: 546.32,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 624.45,
    cy: 550.63,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 610.86,
    cy: 556.93,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 606.72,
    cy: 521.87,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 610.26,
    cy: 540.01,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 610.26,
    cy: 540.01,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 612.54,
    cy: 548.98,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 618.67,
    cy: 542.96,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 622.14,
    cy: 546.32,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 617.43,
    cy: 563.44,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 612.79,
    cy: 561.38,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 624.15,
    cy: 566.47,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 622.29,
    cy: 570.89,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 626.45,
    cy: 561.38,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 611.52,
    cy: 565.25,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 617.43,
    cy: 571.49,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 621.53,
    cy: 552.4,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 615.93,
    cy: 561.38,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 615.93,
    cy: 554.67,
    r: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "ARM-2",
    "data-name": "ARM",
    className: "cls-24",
    d: "M589.14,492.73c1.54.1,6.88-2.29,7.81-6.91,1.3-6.48,6.73-5.48.62-8.94-5.64-3.19-21.68-3.26-25.31-2.12s-8.44,5.61-8.88,6.49-3.23,7.43-3.23,7.43,6.06,4.35,9.62,1a14,14,0,0,1,11.09-3.8,7.56,7.56,0,0,1,4.89,2.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "DRESS-3",
    "data-name": "DRESS",
    className: "cls-11",
    d: "M756.08,460.19c7.85,2.27,17.39,6.21,23.78,52.48s38,173.09,38.55,176.28S692.08,701.29,650.6,674.17c0,0,37.33-180.84,50.12-205.39,3.36-6.45,13.94-9.16,23.6-9.95S744.28,456.77,756.08,460.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HEAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NECK-2",
    "data-name": "NECK"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M747.54,437.86s-2.8,11.88,8.54,22.33c0,0-26.47,13.21-44,1.1,0,0,9.52-10.54,8.49-23.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M749.24,450.76c-8,5.85-20.69,11.94-33.78,5.85,2.62-4.28,5.72-11.1,5.11-18.75h27A22.27,22.27,0,0,0,749.24,450.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "FACE-2",
    "data-name": "FACE",
    className: "cls-24",
    d: "M760,439.08s-28.14,27.66-48,5.6c-16.9-18.81,7.59-63,32.78-52C765.63,401.74,760,439.08,760,439.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HAIR-2",
    "data-name": "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M738.48,395.45s.29,25.29,21.66,34.39l-.71,13.69s20.48-.29,22.88-17c3.73-25.94-8.61-42.26-25.32-45.64s-45.12-3-48.6,16.18c-.75,4.13.53,18.26.53,18.26S717,390.92,738.48,395.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M738.48,394.25S729.8,418.94,752.33,428"
  })), /*#__PURE__*/React.createElement("path", {
    id: "EAR",
    className: "cls-24",
    d: "M758.86,439.57s10.83-1,9.79-6-9.07-3.7-9.07-3.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_HAND-2",
    "data-name": "RIGHT HAND"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BOWL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M689.38,589a60.31,60.31,0,0,1-69.91,48.88h0A60.32,60.32,0,0,1,570.59,568Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M689.38,589a60.31,60.31,0,0,1-69.91,48.88h0A60.32,60.32,0,0,1,570.59,568Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M660.06,625.48a53.15,53.15,0,0,1-67.26-5.22c2.39-3,18.61,8.33,34.82-.33C656.35,604.6,659.76,623.23,660.06,625.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAND-3",
    "data-name": "HAND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M769.46,483.36c2.17-14.57-15-18.41-24.34-5.28-8.7,12.26-26.29,67.62-26.29,67.62-6.77,3.56-78.13,51.25-75.74,58.88,1.33,4.25,55.93-14,89.45-33.86C739.16,566.47,763.79,521.26,769.46,483.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M651,605c-2.76,1.24-20.17,8.56-24,8.38s-11.34-5.36-12-6.11-3.37-4.94-3.37-4.94,2.92-3,5.59,0c3.17,3.57,8.84,2.7,11.83,1.5,1.25-.5,3.15-2.35,2.19-3.93s-5.82.19-7.32-.15a4.5,4.5,0,0,1-3-3l9.15-3c1.47-.48,12-.05,18.06,2.66S657.44,602.1,651,605Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "MAN"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEGS-3",
    "data-name": "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_LEG-3",
    "data-name": "RIGHT LEG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHOES-4",
    "data-name": "SHOES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M332,1061.49c0,10.16-7.83,13.87-7.82,31.9h80s1.43-18.6-18.9-19.17c-17.44-.49-30.62-11.16-30.43-12.73S332,1061.49,332,1061.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M323.57,1091.54h81.14a0,0,0,0,1,0,0v1.78a2.47,2.47,0,0,1-2.47,2.47H326a2.47,2.47,0,0,1-2.47-2.47v-1.78A0,0,0,0,1,323.57,1091.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M360.45,1079a1.07,1.07,0,0,1-.25,0,1.19,1.19,0,0,1-.93-1.42c.06-.3,1.55-7.27,6.1-9.32,2.13-1,4.49-.71,7,.75a1.2,1.2,0,1,1-1.2,2.08c-1.86-1.06-3.45-1.27-4.85-.64-2.86,1.29-4.39,5.94-4.74,7.62A1.2,1.2,0,0,1,360.45,1079Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M370.66,1079.62a1,1,0,0,1-.3,0,1.2,1.2,0,0,1-.86-1.47c.06-.21,1.43-5.33,5.47-7.21,2.24-1,4.79-.88,7.58.46a1.2,1.2,0,0,1-1,2.17c-2.11-1-4-1.16-5.52-.45-3,1.41-4.15,5.6-4.16,5.64A1.22,1.22,0,0,1,370.66,1079.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "PANT",
    className: "cls-7",
    d: "M370.73,1057.72a78.43,78.43,0,0,1-18.31,4.4c-10.64,1.37-30.12-1.4-30.12-1.4-20.47-32.14-41.73-124.4-38.28-200.26,2-42.85,26.76-61.59,10.81-99.48-14.08-31.24-63.53-117.09-71.66-187.74-3-25.68,1.17-44.48,8.94-57.86,5.13.74,10.22,1.41,15.22,2,34.06,4.26,64.29,6.1,78.53,5.92,16.59,31.81,34.81,90.06,47.45,205.3l3.38,49.65C378.33,803,370.64,926.17,370.73,1057.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_LEG-3",
    "data-name": "LEFT LEG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHOES-5",
    "data-name": "SHOES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M148.48,1061.49c0,10.16-7.83,13.87-7.83,31.9h80.63s1.43-18.6-18.9-19.17c-17.44-.49-29.44-11.16-29.25-12.73S148.48,1061.49,148.48,1061.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M140.65,1091.54h81.14a0,0,0,0,1,0,0v1.78a2.47,2.47,0,0,1-2.47,2.47H143.13a2.47,2.47,0,0,1-2.47-2.47v-1.78A0,0,0,0,1,140.65,1091.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M178.33,1079.62l-.24,0a1.19,1.19,0,0,1-.93-1.42c.06-.29,1.55-7.27,6.1-9.32,2.13-1,4.49-.71,7,.75a1.2,1.2,0,1,1-1.2,2.08c-1.86-1.06-3.45-1.27-4.85-.64-2.86,1.29-4.39,5.94-4.74,7.62A1.21,1.21,0,0,1,178.33,1079.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M188.55,1080.22a1,1,0,0,1-.3,0,1.2,1.2,0,0,1-.86-1.47c.05-.21,1.43-5.33,5.47-7.2,2.24-1,4.79-.89,7.58.45a1.2,1.2,0,0,1-1,2.17c-2.11-1-4-1.16-5.52-.44-3,1.4-4.15,5.59-4.17,5.63A1.2,1.2,0,0,1,188.55,1080.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "PANT-2",
    "data-name": "PANT",
    className: "cls-7",
    d: "M255.78,743.26c-.54,5.09-3.15,22.51-5.11,34-4.91,28.86-68.87,272.15-70.3,284.27,0,0-5.8,1.8-17.12,2.14a256.75,256.75,0,0,1-25.73-1c-12.55-35.19-23.24-128-6.25-198,9.11-37.57,34.93-60.5,36.21-93.38-6-32.8-34.84-134.84-26.73-206.59,3.39-29.94,13.95-49.5,27-61.56,25.12,6.3,53.49,11,79.61,14.25C259.54,549.46,270,611,255.78,743.26Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_HAND-3",
    "data-name": "RIGHT HAND"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HAND-4",
    "data-name": "HAND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M461,481.9C369.76,411,360,333.13,358.22,313.48c-2.55-28.66,12.29-51.42,51.14-27.63,33.46,20.47,67.72,94.06,88.81,131.64,42-38.1,101.85-72.2,108.24-76.46,15-10,18.23-.3,10.35,10.07-9.09,12-71.79,118.11-102.68,136.47C502.67,494.35,481.26,497.61,461,481.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M477,378.16c-18.47,31.3-52.82,48.78-66.62,54.81-43.23-54.16-50.86-105-52.15-119.49-2.55-28.66,12.29-51.41,51.14-27.64C433.18,300.42,457.4,341.9,477,378.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M630.81,314.15c-1,3.18-5.24,7.72-1.74,8.19,1.81.24,15.17,0,16.07,5.05a10.58,10.58,0,0,1-1.34,6.88,7.37,7.37,0,0,1-.45,7.86c1.34,2.91,1.3,6.42-.12,7.76,0,0,2,7.41-1.1,8.61-9.68,3.74-26.39,1.85-32,.25-4.87-1.39-8.82-6.11-8.82-16.65,0-4.32,5.81-14.77,9.69-18.91,1.59-1.69,7.48-8.5,9.41-10.32a24.56,24.56,0,0,0,6.08-9.59S633.55,305.26,630.81,314.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M641.83,326.2c0,2.23-13.4.76-15.8.93-3.39.24-4,7.31.38,7.24a89.48,89.48,0,0,0,17.54,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M643.24,342.13c-14.51.81-18.24,0-18.24,0-2.11.11-3.71-7.54,1.41-7.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M642.54,349.89c-13.7,1-18.24,0-18.24,0-2-.05-3.38-7.86.7-7.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M628,350.33s-4.69-1.13-5,1.84c-.63,5.27,1.83,6.2,14.16,5.73"
  })), /*#__PURE__*/React.createElement("path", {
    id: "T-SHIRT",
    className: "cls-8",
    d: "M401.94,425.57S472.67,390,479.6,366.76c0,0-39.92-67.78-77.61-87.06S314.6,294.24,401.94,425.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "TORSO",
    className: "cls-8",
    d: "M211.24,549c-64.86-16.39-78.37-25.14-47.41-68.78C188.54,445.39,192.7,313.39,226,270.82c32.65-41.76,79.22-33,95.16-31.06,0,0,27.12-.89,78.25,36.8,65.2,48.07,28.06,104.12,19.05,122.74-5.5,11.37-28.28,48.49-85.13,112.79-8.33,9.41-.21,28.75,1.19,32.56S282.38,567,211.24,549Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-2",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NECK-3",
    "data-name": "NECK"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M355.75,194.32s-7.38,27.61-36.13,45.76c0,0,25.8,29.62,74.16,32.48,0,0-21-19.4,7.63-57.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M356.75,194.76c-.74,1.68-1.34,3.09-1.74,4.12,0,0-5,16.88.51,30.38,4.26,10.49,20.91,26.39,29.9,25.76.14-9.22,4.6-25,16-40.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "FACE-3",
    "data-name": "FACE",
    className: "cls-31",
    d: "M354.71,198.09S358.15,215.8,362,222c6.73,10.84,23.87,21.26,31,20.58,4.9-.47,11.44-.51,22-21.58,3-6,16.43-44.52,14.78-46.79S383,149,378.46,153.07,357.88,190.05,354.71,198.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HAIR-3",
    "data-name": "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M359.89,186.64s9,4.51,13.09-12c3.66-14.71,7.82-16.29,23.28-3.64,12.58,10.3,39.76,22.22,49.78,9.68,9.18-11.5,1.39-20.75-7.79-19.88-11.18,1.05-14.21-23.86-38.45-28.3C380.44,128.92,373,144.12,373,144.12s-9.57-7-16.85,3.64c-9.18,13.38-1.58,50.56-1.58,50.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M392.53,165c12.44,12.55,32,28.1,44.08,22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M373.26,144.9s-1.61-7.49-9-6.17"
  })), /*#__PURE__*/React.createElement("path", {
    id: "EAR-2",
    "data-name": "EAR",
    className: "cls-31",
    d: "M360.4,186.87s-2.26-7.63-8.22-5.53c-4.45,1.57,2.29,17.3,2.29,17.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "APRON-3",
    "data-name": "APRON"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SHADOW-4",
    "data-name": "SHADOW",
    className: "cls-29",
    d: "M247.33,517.42c34,4.26,64.29,6.1,78.53,5.92h0a222.53,222.53,0,0,1,9.88,22c4,16.64,11.54,41.2,19.29,66.31l16.86,104.53c-16.18,10.48-53.5,17.18-90.25,17.87-6.17-12.36-13.45-27-20.74-43q-1.5,19.88-4,42.51c-38-2.32-69.6-12.15-67.81-32.24,10.49-118-11.22-181.5-18.6-197.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "APRON-4",
    "data-name": "APRON",
    className: "cls-34",
    d: "M303.2,237.49s70.26,109.31-28.53,181.83c-92.68,68-106.77,54-106.77,54l-8.63,13.63s49.13,80,42.1,207.65c-2.4,43.56,180.45,37.64,178.82,7.09S327.14,522.56,333.3,512.09s84.37-79.52,90.07-142.27c4.52-49.73-15.93-86.77-15.93-86.77l-13.59-11.4s17.31,48.26,8.13,83.7c0,0-43.21-6.11-46.66-8.14s-11.79-72.12-34.47-107.13C316.45,233.29,303.2,237.49,303.2,237.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_HAND-3",
    "data-name": "LEFT HAND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M445.92,609.6h57a12.53,12.53,0,0,1,12.53,12.53v4.66A12.53,12.53,0,0,1,503,639.32h-57a0,0,0,0,1,0,0V609.6a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HAND-5",
    "data-name": "HAND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M417.1,594.06c1.77,2.89,5,4.88,10,4.29,6.77-.8,27.57-2.61,35.72,6.56,5.25,5.9,9.92,10.14,9.92,10.14s-4.14,4.3-9.75,1.84c-9.79-4.28-22.18.76-26.25,3s-16.95,4.82-29.46-8S417.1,594.06,417.1,594.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M291.76,512.2h0c37.7,44.18,111.53,97.42,118.77,102.37,5.74,3.93,17.75-3.73,10.37-14.46-7.82-11.4-59.22-103.35-89.21-135.46.57-39.79,3.85-156.28-19-193.9-18.44-30.42-63.07-10.27-72.63,16.87C227.32,323.87,225.24,395,273.33,485.23,275.74,489.76,284.3,504,291.76,512.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.78,388.15c-26,10.89-67.93,14.77-90.12,16.1C228.2,352.73,231.5,312,240.09,287.62c9.56-27.14,54.18-47.28,72.63-16.87C326.23,293,330.59,342.89,331.78,388.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "T-SHIRT-2",
    "data-name": "T-SHIRT",
    className: "cls-8",
    d: "M226.8,392s70.05,4.69,106.31-11.2c0,0,8.48-135.32-56.32-131C199,255,226.8,392,226.8,392Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 445.92,
    cy: 624.41,
    r: 14.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 426.68,
    y: 620.73,
    width: 18.64,
    height: 7.21,
    rx: 3.04
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TABLE"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 327.56,
    y: 639.92,
    width: 877.14,
    height: 23.33,
    rx: 9.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1154.29,
    y: 663.24,
    width: 22.49,
    height: 430.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 355.48,
    y: 663.24,
    width: 22.48,
    height: 430.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "355.48 663.24 377.96 663.24 377.96 672.86 355.48 670.46 355.48 663.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1176.78 663.24 1176.78 673.46 1154.29 670.46 1154.29 663.24 1176.78 663.24"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M396.52,181.09s-4.58-3.54-12.47,0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 389.48,
    cy: 192.28,
    rx: 3.56,
    ry: 2.75,
    transform: "translate(132.84 542.71) rotate(-80.06)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 414.75,
    cy: 198.65,
    rx: 3.56,
    ry: 2.75,
    transform: "translate(126.36 556.86) rotate(-76.76)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "406.5 191.5 407.5 209.5 401.41 211.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M385.5,211.5s0,8,6,10"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 358.5,
    cy: 188.5,
    r: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 716.67,
    cy: 415.04,
    rx: 3.01,
    ry: 2.5,
    transform: "translate(76.38 940.3) rotate(-69.44)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 733.17,
    cy: 420.54,
    rx: 3.01,
    ry: 2.5,
    transform: "translate(81.93 959.32) rotate(-69.44)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "725.39 415.04 717.5 423.5 720.74 429.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M733.56,410s3.94-.52,7.94,3.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M719.5,435.5A12.51,12.51,0,0,0,732.35,433"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M762,390.28c-8,.56-14.94-6.2-14.94-6.2s6-7.67,13.92-8.24S775.91,382,775.91,382,770,389.71,762,390.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M733.26,374.56c3.83,7,13.28,9.25,13.28,9.25s3.25-9.15-.57-16.17-13.28-9.25-13.28-9.25S729.44,367.54,733.26,374.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 747.81,
    cy: 382.91,
    r: 4.02,
    transform: "translate(-84.5 268.45) rotate(-19.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M746.39,385.41s19.19,15.32,17.4,37c.42.26,4,0,4,0s6.39-18.79-10.7-34.08"
  }), /*#__PURE__*/React.createElement("g", {
    id: "JUG"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1185,598.42c0,18.07-10,33.48-24.09,39.51h-26.31c-14.07-6-24.08-21.44-24.08-39.51,0-15.92,7.77-29.79,19.25-37a7.35,7.35,0,0,0,3.46-6.23h0a7.34,7.34,0,0,0-3.39-6.18l-3.7-2.36a1.27,1.27,0,0,1,.68-2.33h34.37a2.35,2.35,0,0,1,2.32,2.68l-1.22,8.2a7.35,7.35,0,0,0,3.46,6.22C1177.21,568.64,1185,582.5,1185,598.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1179.91,598.63c0,18.46-10.19,34.21-24.51,40.37h-26.78c-14.32-6.15-24.51-21.91-24.51-40.37,0-16.27,7.91-30.43,19.59-37.78a7.53,7.53,0,0,0,3.53-6.36h0a7.55,7.55,0,0,0-3.46-6.33l-3.76-2.41a1.29,1.29,0,0,1,.7-2.37h35a2.37,2.37,0,0,1,2.35,2.73l-1.23,8.38a7.52,7.52,0,0,0,3.52,6.36C1172,568.2,1179.91,582.36,1179.91,598.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1167.32,566.86h6.21A20.18,20.18,0,0,1,1193.71,587v8.82a15.48,15.48,0,0,1-15.47,15.48h0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M505.71,982.54S508.17,815,586.38,715.61c0,0-40.34,56.48-53.3,266.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M521.72,982.54s17.56-179.28-76.34-246.35c0,0,76.92,70.07,43.9,246.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M511.45,980S510.86,820,425.72,782c0,0,85.14,61.9,57.69,198.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M497.07,982.54s-20-178.9,44.23-241.48c0,0-35.59,70.86-19.58,241.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M518.28,982.54s0-140.27,80.61-166.52c0,0-65.33,71.33-55.61,166.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M478.44,982.54S490,907.91,431.26,874.46c0,0,68.55,15.09,65.81,108.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 460.58,
    y: 981.67,
    width: 100.58,
    height: 100.58,
    rx: 13.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawkitDailyLifeVectorIllustration05);
export default __webpack_public_path__ + "static/media/drawkit-daily-life-vector-illustration-05.64f171c203bda5013753af2a54bdff81.svg";
export { ForwardRef as ReactComponent };